import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { AuthService } from './auth.service';
import { SettingsService } from '../common/settings.service';
import 'rxjs/add/operator/map';
//import { userInfo } from 'os';
import { UserComponent } from '../../components';

@Injectable()
export class UsersService {

	constructor(
		private http: Http,
		private authService: AuthService,
		private settings: SettingsService

	) { }

	getUserStatistics(dateRange) {
		const headers = new Headers();
		headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
		headers.append('Authorization', this.authService.getUserToken());

		return this.http.post(this.settings.serverNomenclator + 'PortalOperator/GetClientStatistics', dateRange, { headers: headers })
			.map(res => res.json());
	}

	getAllUsers() {
		const headers = new Headers();
		headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
		headers.append('Authorization', this.authService.getUserToken());

		return this.http.get(this.settings.serverNomenclator + 'PortalOperator/GetClientList', { headers: headers })
			.map(res => res.json());
	}

	getUser(id) {
		const headers = new Headers();
		headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
		headers.append('Authorization', this.authService.getUserToken());

		return this.http.get(this.settings.serverNomenclator + 'PortalOperator/GetClientDetails?portalOperatorId=' + id, { headers: headers })
			.map((res) => res.json());
	}

	getUserPhone(phoneNumber) {
		const headers = new Headers();
		headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
		headers.append('Authorization', this.authService.getUserToken());

		return this.http.get(this.settings.serverNomenclator + 'PortalOperator/GetClientPhone?phoneNumber=' + phoneNumber, { headers: headers })
			.map((res) => res.json());
	}
	getUserEmail(emailAddress) {
		const headers = new Headers();
		headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
		headers.append('Authorization', this.authService.getUserToken());

		return this.http.get(this.settings.serverNomenclator + 'PortalOperator/GetClientEmail?emailAddress=' + emailAddress, { headers: headers })
			.map((res) => res.json());
	}

	getUserFines(userId: string) {
		const headers = new Headers();
		headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
		headers.append('Authorization', this.authService.getUserToken());

		return this.http.get(this.settings.serverMain + 'Fine/GetFinesOf?portalOperatorId=' + userId, { headers: headers })
			.map((res) => res.json());
	}

	getUserPayments(userId: string) {
		const headers = new Headers();
		headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
		headers.append('Authorization', this.authService.getUserToken());

		return this.http.get(this.settings.serverMain + 'Payment/GetListOf?portalOperatorId=' + userId, { headers: headers })
			.map((res) => res.json());
	}
	deleteUser(userId: string) {
		const headers = new Headers();
		headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
		headers.append('Authorization', this.authService.getUserToken());


		return this.http.get(this.settings.serverMain + 'Main/B5F0B24E18C46C9884D2FA1B3FA47B1?poId=' + userId, { headers: headers })
			.map((res) => res.json());
	}


}
